// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__3XVXk","rootSmall":"AddTileButton_rootSmall__1OUH4"};